import { Button, Tag, Tooltip } from "antd"
import { ColumnsType } from "antd/es/table";
import { RedemptionGrouped } from "../../../api/redemption/RedemptionGrouped";
import { formatDateTimeISO } from "../../../utils/date";
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled, QuestionCircleFilled, StopFilled } from "@ant-design/icons";
import { ReactNode } from "react";

const columns: (handleViewDetails: (rg: RedemptionGrouped) => void) =>
               ColumnsType<RedemptionGrouped> = (handleViewDetails) => ([
  {
    title: "Order Date",
    dataIndex: "orderDate",
    key: "orderDate",
    // width: 90,
    sorter: (a, b) =>
      a.orderDate?.localeCompare(b.orderDate!!) ?? -1,
    render: (date: string) => formatDateTimeISO(date),
  },
  {
    title: "Arrival Date",
    key: "arrivalDate",
    // width: 90,
    sorter: (a, b) => {
      const aDate = a.kycs[0]?.Kyc?.arrivalDate || "";
      const bDate = b.kycs[0]?.Kyc?.arrivalDate || "";
      return aDate.localeCompare(bDate);
    },
    render: (_, record) => {
      const arrivalDate = record.kycs[0]?.Kyc?.arrivalDate;
      return arrivalDate ? formatDateTimeISO(arrivalDate) : "-";
    },
  },
  {
    title: "Online Order Number",
    dataIndex: "orderId",
    key: "orderId",
    // width: 100,
    sorter: (a, b) => a.orderId.localeCompare(b.orderId),
    render: (orderNumber: string) => orderNumber === "" ? "-" : orderNumber,
  },
  {
    title: "Form Filled",
    dataIndex: "status",
    key: "status",
    // width: 120,
    sorter: (a, b) => a.redeemedCount - b.redeemedCount,
    render: (status: string) => {
      console.log("Status:", status);
      const parts = status.split("/");
      const [redeemed, total] = parts.map((x) => parseInt(x));

      let color = "orange";
      if (redeemed === total) {
        color = "green";
      }

      return <Tag color={color}>{status}</Tag>;
    },
  },
  {
    title: "QR Sent Status",
    dataIndex: "sentStatus",
    key: "sentStatus",
    // width: 120,
    sorter: (a, b) => a.sentCount - b.sentCount,
    render: (status: string) => {
      console.log("QR Sent Status:", status);
      const parts = status.split("/");
      const [sent, total] = parts.map((x) => parseInt(x));

      let color = "orange";
      if (sent === total) {
        color = "green";
      }

      return <Tag color={color}>{status}</Tag>;
    },
  },
  {
    title: "Order Email",
    dataIndex: "orderEmail",
    key: "orderEmail",
    // width: 100,
    sorter: (a, b) => a.orderEmail?.localeCompare(b.orderEmail!!) ?? -1,
    render: (email) => email ?? "-",
  },
  {
    title: "Error",
    dataIndex: "error",
    key: "error",
    render: (_, rec) => {
      let toolTipText = "No errors";
      let icon: ReactNode = undefined;
      if (rec.canceled) {
        toolTipText = "Order cancelled";
        icon = <StopFilled style={{ color: "lightred" }} />;
      } else if (rec.kycs.some(x => x.ProcessedErrors)) {
        toolTipText = "One or more processing errors";
        icon = <CloseCircleFilled style={{ color: "red" }} />;
      } else if (rec.kycs.some(x => x.IsSent && x.KycSubmittedBy === null
                && !x.InternalSku.startsWith("joy-") && !x.InternalSku.startsWith("tgt-")
      )) {
        toolTipText = "One or more KYCs not submitted";
        icon =  <ExclamationCircleFilled style={{ color: "orange" }} />;
      } else if (rec.kycs.some(x => x.InternalSku.startsWith("joy-"))) {
        toolTipText = "Unable to determine processing status for Joytel eSIMs";
        icon = <QuestionCircleFilled style={{ color: "#91caff" }} />;
      } else {
        icon = <CheckCircleFilled style={{ color: "#389e0d" }}/>;
      }

      return (
        <Tooltip title={toolTipText}>
          {icon}
        </Tooltip>
      );
    }
  },
  {
    title: "Action",
    key: "operation",
    // width: 100,
    render: (text, record) => {
      const actionReqd = record.kycs.some(x => (
        x.AssignedSimId === undefined
            || x.AssignedSimId === null
            || x.AssignedSimId?.length === 0)
        && x.Status === "REDEEMED");
      return (
      <>
        <Button
          type={actionReqd ? "primary" : "dashed"}
          onClick={() => handleViewDetails(record)}
        >
          {actionReqd
            ? "Action Required" : " View Details"}
        </Button>
      </>
    )},
  },
]);

export default columns;